import React, { useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { analyticsTrackEvent } from "../_utils/common";
import { AI_DOCUMENT, AI_SHORT_FORM_ALL } from "../_utils/routes";
import { useHistory } from "react-router-dom";
import { NEW_DOCUMENTS_ENDPOINT } from "../_actions/endpoints";
import axios from "axios";
import Format from "string-format";
import { handleHTTPError } from "../_actions/errorHandlerActions";

import { FeatureCodes } from "../_components/details/constants";
import TldrAiCard from "./TldrAiCard";
import { AI_FORM_CARDS } from "../_utils/constants";
import connectedFeatureAvailabilityWrapper from "../_components/common/withFeatureAvailability";
import { FaRobot } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { Box, Flex, Icon, Text } from "@chakra-ui/react";

function TldrObjectives(props) {
  const { t } = useTranslation(["ai", "billing"]);
  const signalToken = axios.CancelToken.source();
  const [loading, setLoading] = useState(false);

  let history = useHistory();

  function createNewDocument() {
    if (loading) {
      return true;
    }
    setLoading(true);
    axios
      .post(NEW_DOCUMENTS_ENDPOINT, {}, { cancelToken: signalToken.token })
      .then((res) => {
        setLoading(false);
        history.push(Format(AI_DOCUMENT, res.data.id));
      })
      .catch((error) => {
        setLoading(false);
        props.handleHTTPError(error, props);
      });
  }

  function handleOnComplete(card) {
    if (card.id === 1) {
      props.checkFeatureAvailability(
        FeatureCodes.AI_LONG_FORM_EDITOR,
        () => createNewDocument()
      );
      analyticsTrackEvent("longFormEditor");
    } else if (card.id === 2) {
      // props.onComplete("welcome");
      history.push(AI_SHORT_FORM_ALL)
      analyticsTrackEvent("shortFormEditor");
    } else if (card.id === 3) {
      props.onComplete("welcome", { tab: "design" });
      analyticsTrackEvent("launchDesigner");
    }
  }

  return (
    <>
      {" "}
      <Box display={["none", "none", "block"]}>
        <Flex direction={"column"} mt={6} align={"center"}>
          <Icon
            as={FaRobot}
            fontSize={"2rem"}
            color={"primary.400"}
            boxSize={10}
          />
          <Text
            fontFamily={"Rubik"}
            fontStyle={"normal"}
            fontWeight={"500"}
            fontSize={"1.5rem"}
            lineHeight={"28px"}
            letterSpacing={"0em"}
            textAlign={"center"}
            color={"brand.white"}
            mt={"16px"}
            mb={"0px"}
          >
            {t("what_to_do")}
          </Text>
          <Text
            fontFamily={"Rubik"}
            fontStyle={"normal"}
            fontWeight={"normal"}
            fontSize={"1rem"}
            lineHeight={"19px"}
            color={"gray.100"}
            mt={"4px"}
            mb={"40px"}
          >
            {t("select_category")}
          </Text>
        </Flex>
      </Box>
      <Flex justify={"center"}>
        <Flex
          direction={["column", "column", "row"]}
          w={"100%"}
          px={"1rem"}
          justify={"center"}
          gap={"1.625rem"}
        >
          {AI_FORM_CARDS.map((card, index) => {
            return (
              <TldrAiCard
                key={index}
                item={card}
                onCardClick={() => handleOnComplete(card)}
              ></TldrAiCard>
            );
          })}
        </Flex>
      </Flex>
    </>
  );
}

TldrObjectives.propTypes = {
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  aiTemplates: state.document.aiTemplates,
  subscription: state.subscription,
  isMobileView: state.app.isMobileView,
});

const mapDispatchToProps = (dispatch) => {
  return {
    handleHTTPError: (error, props) => dispatch(handleHTTPError(error, props)),
  };
};

export default connectedFeatureAvailabilityWrapper(
  connect(mapStateToProps, mapDispatchToProps)(TldrObjectives)
);
